import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { storage } from '../../services/storage';

interface DueReviewsBadgeProps {
  count: number;
}

export const DueReviewsBadge: React.FC<DueReviewsBadgeProps> = ({ count }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Show tooltip only if there are reviews and user hasn't seen it before
    if (count > 0 && !storage.hasSeenTip('reviews_explained')) {
      setShowTooltip(true);
    }
  }, [count]);

  const handleDismissTooltip = () => {
    storage.markTipSeen('reviews_explained');
    setShowTooltip(false);
  };

  if (count === 0) {
    return (
      <div className="due-reviews-badge all-done">
        <span className="badge-icon">&#10004;</span>
        <span>All caught up!</span>
      </div>
    );
  }

  return (
    <div className="due-reviews-wrapper">
      <Link
        to="/practice?mode=review_only"
        className="due-reviews-badge has-reviews"
        onClick={handleDismissTooltip}
      >
        <span className="badge-count">{count}</span>
        <span className="badge-text">
          {count === 1 ? 'review' : 'reviews'} due
        </span>
      </Link>
      {showTooltip && (
        <div className="review-tooltip">
          <button className="tooltip-close" onClick={handleDismissTooltip}>×</button>
          <p>
            These are questions you've seen before. We're bringing them back at
            just the right time to help you remember.
          </p>
        </div>
      )}
    </div>
  );
};
